import Lottie from 'lottie-react'
import styled from 'styled-components'

import { ModalWrap } from '../../../components/modal/ModalWrap'
import { Content } from '../../../components/container/Content'
import { RowBetween } from '../../../components/common'
import { Button } from '../../../components/button'
import { Text } from '../../../components/text'
import { Footer, FOOTER_MIN_HEIGHT } from '../../../components/footer'

import { Color } from '../../../theme/color'

import { ReactComponent as DataAlertIcon } from '../../../assets/ico/market/order/data-alert.svg'
import { ReactComponent as EventBusyIcon } from '../../../assets/ico/market/order/event-busy.svg'
import { ReactComponent as RunningErrorIcon } from '../../../assets/ico/market/order/running-error.svg'
import { ReactComponent as WifiIcon } from '../../../assets/ico/market/order/wifi.svg'
import errorLottie from '../../../assets/lottie/error.json'

interface OrderFailModalProps {
  onDismiss: () => void
}

export function OrderFailModal({ onDismiss }: OrderFailModalProps) {
  return (
    <ModalWrap>
      <StyledContent>
        <Container>
          <Lottie animationData={errorLottie} loop={false} className="lottie" />
          <Text size={24} weight={600} lineHeight={34} block={true}>
            결제에 실패했어요.
          </Text>
          <Text size={16} block={true} color="text_secondary" style={{ marginTop: '8px' }}>
            다음과 같은 상황이 원인일 수 있어요.
          </Text>
          <ReasonBox>
            <Reason>
              <WifiIcon />
              <Text size={16} weight={500}>
                <HighlightText>네트워크 연결</HighlightText>을 확인하여 주세요.
              </Text>
            </Reason>
            <FlexStartReason>
              <RowBetween>
                <RunningErrorIcon />
                <Text size={16} weight={500}>
                  계좌 이용 <HighlightText>제한 시간</HighlightText>에 해당할 수 있어요.
                </Text>
              </RowBetween>
              <Text size={14} block={true} color="primary_5" style={{ marginTop: '4px' }}>
                (23:40~ 00:20)
              </Text>
            </FlexStartReason>
            <Reason>
              <DataAlertIcon />
              <Text size={16} weight={500}>
                잔여 <HighlightText>예치금 정보</HighlightText>를 확인해주세요.
              </Text>
            </Reason>
            <Reason>
              <EventBusyIcon />
              <Text size={16} weight={500}>
                청약 <HighlightText>마감 시간</HighlightText>에 해당할 수 있어요.
              </Text>
            </Reason>
          </ReasonBox>
        </Container>
      </StyledContent>
      <Footer>
        <Button type="primary" size="large" block={true} onClick={onDismiss}>
          닫기
        </Button>
      </Footer>
    </ModalWrap>
  )
}

const StyledContent = styled(Content)`
  padding: 0 24px ${FOOTER_MIN_HEIGHT}px;
  .lottie {
    width: 54%;
    aspect-ratio: 1/1;
    margin: 0 auto -10%;
  }
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
  text-align: center;
`

const ReasonBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  width: 100%;
  margin-top: 32px;
  padding: 32px 0;
  border-radius: 16px;
  background-color: ${Color.gray_1};
`

const Reason = styled(RowBetween)`
  gap: 8px;
`

const FlexStartReason = styled.div`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  > ${RowBetween} {
    gap: 8px;
  }
`

const HighlightText = styled.span`
  color: ${Color.primary_5};
`
